import { useCallback, useEffect, useState } from "react";
import { BasicTable } from "../components/tables/BasicTable";
import { Pagination } from "../components/pagination/Pagination";
import { useNavigate } from "react-router-dom";
import { Search } from "../components/search/Search";
import { useLocation } from "react-router-dom";
import { getAllLeagues } from "../services/leaguesAPI";
import Loader from "../components/ui/loader";

export const Leagues = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const handleLeagueClick = (leagueID) => {
    navigate(`/league/${leagueID}`);
  };

  const columns = [
    { key: "LeagueID", label: "ID", itemID: "LeagueID", clickHandler: handleLeagueClick },
    { key: "name", label: "Name", itemID: "LeagueID", clickHandler: handleLeagueClick },
    {
      key: "description",
      label: "Description",
      itemID: "LeagueID",
      clickHandler: handleLeagueClick,
    },
  ];

  const searchCategories = [
    { value: "id", label: "ID" },
    { value: "name", label: "Name" },
    { value: "description", label: "Description" },
  ];

  const [leagueData, setLeagueData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const fetchLeagues = useCallback(async () => {
    try {
      setIsLoading(true);
      let response = await getAllLeagues(location.search);
      console.log(response);
      if (response.success) {
        setLeagueData(response.data.leagues);
        setPagination(response.data.pagination);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [location.search]);

  useEffect(() => {
    fetchLeagues();
  }, [fetchLeagues]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh] bg-flyers-black">
        <Loader />
      </div>
    );
  }

  return (
    <div className="bg-flyers-black min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <h1 className="font-heading text-3xl font-black uppercase tracking-wide text-flyers-orange">
          Leagues
        </h1>
        <Search categories={searchCategories} />
        <BasicTable columns={columns} data={leagueData} />
        <Pagination pagination={pagination} />
      </div>
    </div>
  );
};
